module.exports = __webpack_public_path__ + "img/2.a555e832.jpg";